/**
 * Created by rickborst on 22/02/2017.
 */

// Action types
const ActionTypes = {
    UPDATE_PAYMENT_DETAILS: 'UPDATE_PAYMENT_DETAILS',
    CLEAR_PAYMENT_DETAILS: 'CLEAR_PAYMENT_DETAILS',
    SET_PAYMENT_TMP: 'SET_PAYMENT_TMP'
};

/**
 * Update payment details action.
 *
 * @param {Object} paymentDetails - New payment details.
 * @returns {Object} Action type and the new user info.
 */
function updatePaymentDetails (paymentDetails) {

    return {
        type: ActionTypes.UPDATE_PAYMENT_DETAILS,
        paymentDetails
    };
}


function setPaymentTmp (paymentTmp) {

    return {
        type: ActionTypes.SET_PAYMENT_TMP,
        paymentTmp
    };
}

/**
 * Clear payment details action.
 *
 * @returns {Object} Action type.
 */
function clearPaymentDetails () {

    return {
        type: ActionTypes.CLEAR_PAYMENT_DETAILS
    };
}

export {
    ActionTypes,
    updatePaymentDetails,
    clearPaymentDetails,
    setPaymentTmp
};



// WEBPACK FOOTER //
// ./src/js/store/actions/paymentdetails.js